import type IPressMaterial from '../../../models/press/press-material.model';
import { MediaFolderApiModel } from './media-folder.api-model';

export class PressMaterialApiModel {
  public static mapToBusinessModel(apiModel: PressMaterialApiModel): IPressMaterial {
    return {
      id: apiModel.id,
      type: apiModel.type,
      title: apiModel.title,
      caption: apiModel.caption,
      license: apiModel.license,
      credits: apiModel.credits,
      path: apiModel.path,
      mediaFolder: apiModel.mediaFolder ? MediaFolderApiModel.mapToBusinessModel(apiModel.mediaFolder) : undefined,
    };
  }

  public id!: string;
  public type!: string;
  public title!: string;
  public caption!: string;
  public license!: string;
  public credits!: string;
  public path!: string;
  public mediaFolder?: MediaFolderApiModel;
}
